import { render, staticRenderFns } from "./design.vue?vue&type=template&id=dc7569aa&scoped=true&"
import script from "./design.vue?vue&type=script&lang=ts&"
export * from "./design.vue?vue&type=script&lang=ts&"
import style0 from "./design.vue?vue&type=style&index=0&id=dc7569aa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc7569aa",
  null
  
)

export default component.exports